export const GCLID_SESSION_STORAGE_KEY = 'gclid'
